export default "__VITE_ASSET__8df2b863__"